import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-verification-badge',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './verification-badge.component.html',
    styleUrls: ['./verification-badge.component.scss']
})
export class VerificationBadgeComponent {
    // true = recensione originata da una quote request (badge blu); false = pagina pubblica (badge grigio)
    @Input() fromQuoteRequest: boolean = false;
    @Input() size: number = 28;
}
